import { isSSR } from 'src/helpers/ssr';
import { isPartner } from 'src/helpers/isPartner';
import { QUERY_MOBILE_APP_ROOM_OFFERS } from 'src/routes/Hotel/store/constants/view';
import { HOTEL_MOBILE_PAGES } from 'src/routes/HotelReviewsPage/constants';

export const getViewInitialState = () => {
  if (isSSR) {
    return {
      isWhitelabel: false,
    };
  }
  const currentPageURL = new URL(window.location.href);
  const pageValue = currentPageURL.searchParams.get(
    QUERY_MOBILE_APP_ROOM_OFFERS,
  );
  return {
    isWhitelabel: window.is_wl || false,
    isWebview: window.is_webview || false,
    isOperatorsHidden: isPartner('mosgortur') || isPartner('mosgortur_public'),
    page: pageValue === 'true' ? HOTEL_MOBILE_PAGES.SEARCHER : null,
  };
};
